import React from 'react'
import { ImageBackground, View, TouchableOpacity, SafeAreaView, Platform } from 'react-native'
import { useDispatch, useSelector } from 'react-redux'
import { DrawerContentScrollView } from '@react-navigation/drawer'
import PropTypes from 'prop-types'

import Assets from '../../../../assets/export'
import ImageComponent from '../../../components/Image'
import { Icon, Txt } from '../../../components'
import { useTheme } from '../../../theming/ThemeProvider'
import { useCustomDrawerStyles } from './styles'
import loginActions from '../../../redux/login/loginActions'
import DividerComponent from '../../../components/Divider'
import UserPhoto from './UserPhoto'
import { initSelector } from '../../../redux/initReducer/initSelector'

const pages = [
  {
    name: 'Dashboard',
    icon: 'Dashboard',
    path: 'dashboard'
  },
  {
    name: 'My Loads',
    icon: 'Loads',
    path: 'loads'
  },
  {
    name: 'My Tractors',
    icon: 'Tractors',
    path: 'tractors'
  },
  {
    name: 'My Offers',
    icon: 'Offers',
    path: 'offers'
  },
  {
    name: 'My Orders',
    icon: 'Orders',
    path: 'orders'
  }
]

const getCurrentPage = (state, key) => state.index === key

export const CustomItem = ({ tableUp, onPress, icon, text, active, testID, badge }) => {
  const { theme } = useTheme()
  return (
    <TouchableOpacity
      activeOpacity={0.8}
      style={{
        flexDirection: tableUp ? 'column' : 'row',
        alignItems: 'center',
        paddingHorizontal: tableUp ? 5 : 20,
        paddingVertical: 13,
        position: 'relative'

      }}
      onPress={onPress}
      testID={testID}
      accessibilityLabel={testID}
    >
      <Icon
        style={[
          { marginRight: tableUp ? 0 : 20 }
        ]}
        name={icon}
        height={20}
        width={20}
        fill={theme.AZTEC}
      />
      <Txt
        text={text}
        color='AZTEC'
        identity={`${tableUp ? 'body3' : 'body1'}${active ? 'Bold' : ''}`}
        style={{ marginTop: tableUp ? 3 : 0 }}
      />
      {active && (
        <View style={{
          position: 'absolute',
          left: -3,
          top: tableUp ? '42%' : 'auto',
          backgroundColor: 'transparent',
          borderStyle: 'solid',
          borderLeftWidth: 7,
          borderRightWidth: 7,
          borderBottomWidth: 8,
          borderLeftColor: 'transparent',
          borderRightColor: 'transparent',
          borderBottomColor: '#000',
          transform: [{ rotate: '90deg' }]
        }}
        />)}
      {Boolean(badge) && (
        <View
          style={{
            position: 'absolute',
            bottom: 24,
            right: 14,
            borderRadius: 50,
            backgroundColor: theme.RED_ORANGE,
            zIndex: 2,
            paddingHorizontal: 4,
            paddingVertical: 2
          }}
        >
          <Txt
            color='WHITE_TEXT'
            text={badge}
            identity='body3'
          />
        </View>
      )}
    </TouchableOpacity>
  )
}

CustomItem.defaultProps = {
  active: false
}

CustomItem.propTypes = {
  tableUp: PropTypes.bool.isRequired,
  onPress: PropTypes.func.isRequired,
  icon: PropTypes.string.isRequired,
  text: PropTypes.string.isRequired,
  active: PropTypes.bool.isRequired,
  testID: PropTypes.string,
  badge: PropTypes.number
}

const CustomDrawer = (props) => {
  const { navigation, state, tableUp } = props
  const dispatch = useDispatch()
  const { theme } = useTheme()
  const styles = useCustomDrawerStyles(theme, tableUp)
  const { offers } = useSelector(initSelector)

  const onLogout = () => {
    dispatch(loginActions.logout(() => navigation.navigate('splash')))
  }

  return (
    <View style={[styles.container, tableUp && styles.largeContainer]}>
      <SafeAreaView />
      {tableUp ? (
        <View style={styles.photo}>
          <UserPhoto />
        </View>
      ) : (
        <ImageBackground
          source={Assets.particles}
          style={styles.header}
        >
          <View style={styles.closeIconContainer}>
            <TouchableOpacity
              activeOpacity={0.8}
              style={styles.closeIcon}
              onPress={() => navigation.closeDrawer()}
            >
              <Icon
                name='Exit'
                height={16}
                width={16}
                fill={theme.TEXT_AND_ICONS}
              />
            </TouchableOpacity>
          </View>
          <View style={styles.logoContainer}>
            <View style={styles.logo}>
              <ImageComponent containerStyle name='logoLight' />
            </View>
          </View>
        </ImageBackground>
      )}
      <DrawerContentScrollView {...props} style={[styles.menu]}>
        {pages.map((page, key) => {
          const currentPage = getCurrentPage(state, key)
          return (
            <CustomItem
              key={page.path}
              onPress={() => navigation.navigate(page.path)}
              icon={page.icon}
              text={page.name}
              active={currentPage}
              tableUp={tableUp}
              testID={`${page.path}Item`}
              badge={page.path === 'offers' ? offers : null}
            />
          )
        })}
        <CustomItem
          onPress={() => navigation.navigate('payments')}
          icon='Payment'
          text='My Payments'
          active={getCurrentPage(state, 5) || getCurrentPage(state, 6)}
          tableUp={tableUp}
          testID='paymentsItem'
        />
        {tableUp && Platform.OS === 'web' && (
          <CustomItem
            key='faqs'
            onPress={() => navigation.navigate('faqs')}
            icon='Faq'
            text='FAQs'
            active={getCurrentPage(state, 7)}
            tableUp={tableUp}
          />
        )}
      </DrawerContentScrollView>
      <View style={styles.logoutContainer}>
        {!tableUp && (
          <>
            <DividerComponent />
            <CustomItem
              onPress={onLogout}
              icon='PowerSettings'
              text='Logout'
              tableUp={tableUp}
              testID='logoutItem'
            />
          </>
        )}
      </View>
    </View>
  )
}

CustomDrawer.propTypes = {
  navigation: PropTypes.object,
  state: PropTypes.object,
  tableUp: PropTypes.bool
}

export default CustomDrawer
